export const csmContactPrefixes = {
  greetingModal: 'ob_portal_csm-contact_greeting-modal',
  profilePanelContact: 'ob_portal_profile-panel_csm-contact',
  scheduleCallModal: 'ob_portal_csm-contact_schedule-call-modal',
};
